module.exports = __webpack_public_path__ + "static/img/bagenova.81cc448.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bagenova.jpg
// module id = 185
// module chunks = 1